import classNames from 'classnames/bind';
import React, { ReactNode, forwardRef, memo } from 'react';
import styles from './Button.module.scss';

type ButtonType = 'button' | 'submit' | 'reset';
type ButtonClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => void;
type DisplayType = 'error' | 'approve' | 'primary';

interface IProps {
  loading?: boolean;
  fill?: boolean;
  title: ReactNode;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  handleOnclick?: ButtonClickHandler;
  customClass?: string;
  iconBefore?: any;
  iconAfter?: any;
  disabled?: boolean;
  displayType?: DisplayType;
  type?: ButtonType;
  handleOnMouseEnter?: ButtonClickHandler;
  handleOnMouseLeave?: ButtonClickHandler;
}

const cx = classNames.bind(styles);

const Button = (
  {
    loading,
    title,
    type,
    disabled,
    iconBefore,
    fill = false,
    customClass = '',
    displayType = 'primary',
    onClick,
    handleOnclick,
    handleOnMouseEnter,
    handleOnMouseLeave,
  }: IProps,
  ref: any,
) => {
  const clasess = cx(
    'button',
    'border border-main text-sub bg-main transition duration-300',
    {
      fill,
      [customClass]: customClass,
      [displayType]: displayType,
    },
  );

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (handleOnclick) {
      handleOnclick(e);
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      onClick={handleClick}
      className={clasess}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      {iconBefore && <span className="mr-2">{iconBefore}</span>}
      <b>{title}</b>
      {/* {iconAfter && <span className="ml-2">{{ iconAfter }}</span>} */}
    </button>
  );
};
export default memo(forwardRef(Button));
